var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "link-bank-container" }, [
    _vm.isLoading
      ? _c("div", { staticClass: "loading-container" }, [
          _c("i", {
            staticClass: "el-icon-loading",
            staticStyle: { "font-size": "48px", color: "#409eff" },
          }),
          _c("p", [_vm._v("Đang tạo phiên liên kết...")]),
        ])
      : _vm.hostedLinkUrl
      ? _c("div", {
          staticClass: "bankhub-container",
          attrs: { id: "bankhub-container" },
        })
      : _vm.error
      ? _c(
          "div",
          { staticClass: "error-container" },
          [
            _c("i", {
              staticClass: "el-icon-circle-close",
              staticStyle: { "font-size": "48px", color: "#f56c6c" },
            }),
            _c("p", [_vm._v(_vm._s(_vm.error))]),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.retryCreateLinkToken },
              },
              [_vm._v("Thử lại")]
            ),
            _c("el-button", { on: { click: _vm.handleClose } }, [
              _vm._v("Đóng"),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }